import { CashierSetCodeScreen, receiptsCashierPolicy, redeemCashierInvitation } from '@krp/resource-receipts-ui'
import { isTransportError } from '@krp/client-runtime'
import { useAppDispatch } from '../../app/hooks'
import { ReceiptsServiceFrame } from './ReceiptsServiceFrame'

/** Страница «Задать свой код»: кассир по приглашению администратора придумывает код; токен и код в состояние приложения не попадают. */
export function CashierSetCodeWindowBinding() {
  const dispatch = useAppDispatch()
  const rules = receiptsCashierPolicy.useQuery()
  return <ReceiptsServiceFrame>
    <CashierSetCodeScreen {...(rules.currentData === undefined ? {} : { rules: rules.currentData })}
      submit={async (token, pin) => {
        try {
          const result = await dispatch(redeemCashierInvitation({ token, pin }))
          return result.ok ? { ok: true as const, cashierName: result.data.cashierName } : { ok: false as const, message: result.error.message }
        } catch (error) { return { ok: false as const, message: isTransportError(error) ? error.message : 'Не удалось получить ответ сервера' } }
      }} />
  </ReceiptsServiceFrame>
}
